<template>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
        <v-icon
        v-bind="attrs"
        v-on="on"
        >
        mdi-alert-circle
        </v-icon>
    </template>
    <span style="white-space: pre-wrap;">{{Tooltip}}</span>
</v-tooltip>
</template>
<script>
export default {
    name:'tooltips',
    props:['Tooltip'],
}
</script>
